module.exports = __webpack_public_path__ + "static/media/EULERITY_TRAINING_GUIDE.39873515.pdf";